export function httpRequestInterceptor(config) {
	return config;
}

export function httpResponseSuccessInterceptor(response) {
	this.$bus.$emit('is-loading', false);
	return response;
}

export function httpResponseInterceptor(error) {
	this.$bus.$emit('is-loading', false);
	let text = 'Su sesión expiró.';
	const { status } = error.response || {};
	if (status === 401) {
		text = error.response;
	} else if (status === 400) {
		text = error.response;
		this.showGenericError(text);
	} else if (status === 403) {
		text = 'No tiene suficientes permisos para realizar ésta acción';
		this.showGenericError(text);
	} else if (status === 500) {
		text = 'No se logró completar la acción, intente de nuevo.';
		this.showGenericError(text);
	}
	return Promise.reject(error.response);
}




// WEBPACK FOOTER //
// ./src/http.js